import { useSelector } from 'react-redux'
import { uiFlagsSelector } from '@src/selectors/uiFlags'

export const useShowWeightLossRecurringCallsBanner = () => {
  const uiFlags = useSelector(uiFlagsSelector)

  return { showBanner: uiFlags.showWeightLossRecurringCallsBanner }
}
